// @flow
import type { Amenity } from '../../../models/step'
import type { AmenityObject } from '../../../api_types'

/**
 * By given raw amenity item return good normalized amenity object
 * @param  {Object} item The amenity item
 * @return {Object}
 * @private
 */
export function buildAmenityItem(item: AmenityObject): Amenity {
  return {
    id: item.key,
    name: item.name,
    category: 'comfort', // missing in v2
    imageUrl: item.image_url || '',
    included: !!item.included,
    selected: !!item.selected,
    price: {
      total: item.price.display,
      raw: parseFloat(item.price.value),
    },
  }
}

/**
 * Ride tracking amenity to include in display in on-demand trips,
 * because on-demand do not have amenities support for now.
 * @type {Amenity}
 */
export const rideTrackingAmenity = buildAmenityItem({
  name: 'Ride tracking',
  price: {
    compact: '$0.00',
    display: '$0.00',
    value: '0.00',
  },
  selected: false,
  image_url: 'https://static.mozio.com/amenities/tracking.svg',
  key: 'ride_tracking',
  included: true,
})

export default buildAmenityItem
